import * as React from 'react';

interface Props {
  children: (didMount: boolean) => React.ReactNode;
}

interface State {
  didMount: boolean;
}

export default class CheckDidMount extends React.PureComponent<Props, State> {
  state = {
    didMount: false,
  };

  componentDidMount() {
    this.setState({ didMount: true });
  }

  render() {
    return this.props.children(this.state.didMount);
  }
}
